<template>
    <div class="main">
      <van-loading type="spinner" vertical>登录中...</van-loading>
    </div>
</template>

<script>
import qs from 'query-string';
import {router} from '../router';
import { Loading } from 'vant';
import store from '../components/store';

export default {
  components: {
    [Loading.name] : Loading
  },
  data() {
    return {
      
    };
  },
  mounted() {
    const q = qs.parse(location.search);
    const {redirect_uri, code} = q;
    const localStorage = window.localStorage;
    if (code) {
      this.$http.post('/member/login_by_wechat_code', {code: code}).then(user => {
        if (user) {
          store.setUser(user);
          if (localStorage) {
            localStorage.setItem('token', user.token);
          }
        }
        if (redirect_uri && redirect_uri.startsWith("http")){
          window.location.href = redirect_uri;
        }
        else if (redirect_uri){
          router.push(redirect_uri);
        }
      });
    } else if (redirect_uri) {
      this.$http.get('/wechat/identify', {redirect : location.href}).then(url => location = url);
    }
    
  },
  methods: {
   
  }
};
</script>

<style lang="less">
  .main{
    margin: 50px auto;
  }
</style>